module.exports = __webpack_public_path__ + "static/media/01.ce993b6f.jpg";